import { setItem } from '@/utils/storage.js';

// 默认配置颜色
export const getDefaultColors = {
  themeColorMain: '#0F62FE',
  themeColorDark: '#0A52D9',
  themeColorLight: '#E6EFFF',
  themeColorDisable: '#9FC0FD',
};

// 设置主题色配置（自定义/默认）
export const setThemeSetting = (tenant = {}) => {
  const body = document.body;
  if (!body || !tenant) return;
  const colors = tenant.themeColorMain ? tenant : getDefaultColors;
  setItem('hly.theme-colors', colors);
  body.style.setProperty('--theme-main', colors.themeColorMain);
  body.style.setProperty('--theme-dark', colors.themeColorDark);
  body.style.setProperty('--theme-light', colors.themeColorLight);
  body.style.setProperty('--theme-disable', colors.themeColorDisable);
};
